module.exports = __webpack_public_path__ + "09239ddcd27f6c11d5847bf7fb9f4b46.pdf";